const PathRoute = {
    home: '/',
    dashboard: '/dashboard',
    login: '/auth/login',
    register: '/auth/register',
    terms_conditions: '/terms-conditions',
    privacy_policy: '/privacy-policy',
    change_password: '/dashboard/change-password',
    analytics_pages: (type) => `/dashboard/analytics/${type}`,
};

export default PathRoute;
